import { AppBar, Toolbar, Typography, Button, Box, Container, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import { Login as LoginIcon } from "@mui/icons-material";

export default function WebsiteHeader({ school, navItems = [], variant = "modern" }) {
  const theme = useTheme();

  const isClassic = variant === "classic";
  const isBold = variant === "bold";

  return (
    <AppBar
      position="sticky"
      elevation={isClassic ? 0 : 2}
      sx={{
        bgcolor: isClassic ? "white" : isBold ? theme.palette.primary.main : "white",
        color: isClassic || (!isBold) ? "text.primary" : "white",
        borderBottom: isClassic ? "2px solid" : "none",
        borderColor: "divider",
      }}
    >
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ gap: 2 }}>
          {/* Logo + name */}
          <Box
            component={Link}
            to="/"
            sx={{ display: "flex", alignItems: "center", gap: 1.5, textDecoration: "none", flexGrow: 0 }}
          >
            {school?.logo && (
              <Box
                component="img"
                src={school.logo}
                alt={school.name}
                sx={{ height: 40, objectFit: "contain" }}
              />
            )}
            <Typography
              variant={isClassic ? "h6" : "subtitle1"}
              fontWeight={700}
              sx={{
                color: isClassic ? "text.primary" : isBold ? "white" : "text.primary",
                fontFamily: isClassic ? "Georgia, serif" : "inherit",
              }}
            >
              {school?.name || "School"}
            </Typography>
          </Box>

          {/* Nav links */}
          <Box sx={{ flex: 1, display: "flex", alignItems: "center", gap: 0.5, flexWrap: "wrap" }}>
            {navItems.map((item, i) => (
              <Button
                key={i}
                href={item.url}
                size="small"
                sx={{
                  color: isClassic ? "text.primary" : isBold ? "white" : "text.primary",
                  textTransform: "none",
                  fontWeight: 500,
                }}
              >
                {item.label}
              </Button>
            ))}
          </Box>

          {/* Login CTA */}
          <Button
            component={Link}
            to="/login"
            variant={isBold ? "outlined" : "contained"}
            size="small"
            startIcon={<LoginIcon fontSize="small" />}
            sx={{
              textTransform: "none",
              borderColor: isBold ? "white" : undefined,
              color: isBold ? "white" : undefined,
            }}
          >
            Login
          </Button>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
